module.exports = __webpack_public_path__ + "img/icon_enterpriserealty_document_03.c0a6343b.svg";